import dynamic from 'next/dynamic';
import { CompProps } from './ConfirmChangesModal.types';

export const ConfirmChangesModalMGP = dynamic<CompProps>(() =>
  import('./ConfirmChangesModal').then(module => module.ConfirmChangesModal)
);
